import { isChroma } from './isChroma';

export const removeDuplicateChroma = data => {
  return data.reduce((acc, d) => {
    return acc.some(product => isChroma(product.netsuite_name)) && isChroma(d.netsuite_name)
      ? acc
      : acc.concat(d);
  }, []);
};
